import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';

export const TOOL_TYPES = {
  TOOL: 'tool',
  GUIDE: 'guide',
  DISCOVERY: 'discovery',
  SOLUTION_SESSION: 'solution-session',
  ASSESSMENT: 'assessment',
} as const;

export type ToolType = (typeof TOOL_TYPES)[keyof typeof TOOL_TYPES];

export const TOOL_TYPE_LABELS: Record<ToolType, string> = appStrings.modules.toolTypes;

export const getToolTypeLabel = (toolType?: ToolType): string =>
  TOOL_TYPE_LABELS[toolType ?? 'tool'] ?? TOOL_TYPE_LABELS.tool;

export type Tool = Readonly<{
  id: number;
  tool_id: string;
  tool_type: ToolType;
  structured_session_type: string | null; // the structured session this tool launches, if any
  title: string;
  description: string;
  internal_description?: string;
  keywords: string[];
  media?: {
    media_id: number;
    media_url: string;
  };
  banner_media?: {
    media_id: number;
    media_url: string;
  };
  navigation:
    | {
        type: 'INTERNAL';
        internal_navigation_url: string;
      }
    | {
        type: 'EXTERNAL';
        external_navigation_url: string;
      };
}>;
